import appHelpers from 'app/app-helpers';

class StripHtml {
  constructor() {
    return (input) => {
      if (typeof input !== 'string') {
        return '';
      }
      const normalizedText = input.replace(/(\r\n|\n|\r)/gm, '').replace(/&nbsp;/gi, ' ');
      return appHelpers.trimHtml(normalizedText, false).replace(/^([\t\r\n]*)$/, '');
    };
  }
}

export default StripHtml;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/strip-html-filter.js